
function galleries(state= [], action) {
    return state;
}

export default galleries;


// WEBPACK FOOTER //
// ./src/reducers/gallery.js